document.addEventListener("DOMContentLoaded", function () {
    const filters = document.querySelectorAll(".filter-details");
    filters.forEach((filter) => {
        filter.setAttribute("open", "");
    });
});
